module.exports = __webpack_public_path__ + "img/09.22c9b8b5.jpg";